//UseRegisterVehicleType
import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import history from '../../services/history';
import { InitialVehicleType } from '../../store/ducks/vehicleType/types';
import { VehicleFormType } from '../../components/FormVehicleType/validations';

export default function UseRegisterVehicleType() {
  const [loading, setLoading] = useState(false);

  async function execute(data: VehicleFormType) {
    try {
      setLoading(true);
      const response = await api.post(`v1/backoffice/vehicleType`, {
        costPerAssistant: data.costPerAssistant,
        costPerKilometer: data.costPerKilometer,
        costPerOrder: data.costPerOrder,
        costPerTon: data.costPerTon,
        costPerCubicMeter: Number(data.costPerCubicMeter),
        driverCost: data.driverCost,
        packLoadWeight: data.packLoadWeight * 100,
        payloadCapacity: data.payloadCapacity * 100,
        vehicleType: data.vehicleType,
      });

      if (response.status === 201) {
        toast.success(ToastMessages.vehicleType.success.registerVehicleType);
        history.push('/home/vehicle-types');
      } else {
        toast.error(`Erro ${response.status} ao criar tipo veíulo`);
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.vehicleType.error.registerVehicleType);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
